import get from 'lodash/get';
import { newsletterFrequencies } from 'shared/constants/news/newsletterFrequencies';

export const newsletterSettingsParser = ({ newsletter }) => {
  const countriesList = get(newsletter, 'countryCode', null);

  return {
    frequency: get(newsletter, 'frequency', newsletterFrequencies.NONE),
    newsTypes: get(newsletter, 'news', []),
    industryTypes: get(newsletter, 'classifications[0].values', []),
    limitToFollowedAnalysts: get(newsletter, 'limitToFollowedAnalysts', false),
    useNewsFeedPreferences: get(newsletter, 'useNewsFeedPreferences', false),
    countriesList: countriesList ? countriesList.split(';') : [],
  };
};

export const emailNotificationsParser = ({ emailNotifications }) => {
  return {
    frequency: emailNotifications.frequency,
    type: emailNotifications.type,
  };
};

export const newsFeedSettingsParser = preferences => {
  const countriesList = get(preferences, 'newsFeed.countryCode', null);

  return {
    newsTypes: get(preferences, 'newsFeed.news', []),
    industryTypes: get(preferences, 'newsFeed.classifications[0].values', []),
    limitToFollowedAnalysts: get(preferences, 'newsFeed.limitToFollowedAnalysts', false),
    countriesList: countriesList ? countriesList.split(';') : [],
  };
};

export const initialSettingsParser = (prefs = {}) => ({
  newsFeed: newsFeedSettingsParser(prefs),
  newsletter: newsletterSettingsParser(prefs),
  emailNotifications: emailNotificationsParser(prefs),
});
